import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CHANGE_PRIMARY_JOTR_REQUEST = 'CHANGE_PRIMARY_JOTR_REQUEST';
export const CHANGE_PRIMARY_JOTR_SUCCESS = 'CHANGE_PRIMARY_JOTR_SUCCESS';
export const CHANGE_PRIMARY_JOTR_FAILURE = 'CHANGE_PRIMARY_JOTR_FAILURE';

function requestPrimary() {
  return {
    type: CHANGE_PRIMARY_JOTR_REQUEST,
  };
}

function receivePrimary(data) {
  return {
    type: CHANGE_PRIMARY_JOTR_SUCCESS,
    jotrs: data
  };
}

function rejectPrimary() {
  return {
    type: CHANGE_PRIMARY_JOTR_FAILURE,
  };
}

export function changePrimaryJotr(customerId, jotrId) {
  return (dispatch) => {
    dispatch(requestPrimary());

    const promise = () => ApiService
      .changePrimaryJotr(customerId, jotrId)
      .then((response) => {
        dispatch(receivePrimary(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectPrimary, true));
        }
      });
    return promise();
  };
}
